import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const COMPANY = {
  name: "La Minipelle Berjalienne",
  fullName: "La Minipelle Berjalienne",
  phone: "07 67 48 03 22",
  phoneTel: "+33767480322",
  email: "laminipelleberjalienne@gmail.com",
  whatsapp: "33767480322",
  address: "225 avenue des Marronniers, 38300 Bourgoin-Jallieu",
  city: "Bourgoin-Jallieu",
  mapsEmbed: "https://www.google.com/maps?q=225+avenue+des+Marronniers,+38300+Bourgoin-Jallieu&z=15&output=embed",
  mapsDirections: "https://www.google.com/maps/dir/?api=1&destination=225+avenue+des+Marronniers%2C+38300+Bourgoin-Jallieu",
};
